module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Type</th>\r\n        <th>Destination</th>\r\n        <th>Extension</th>\r\n        <th>Usage</th>\r\n        ';
 if (!simpleView) { 
__p+='\r\n        <th>Send docs?</th>\r\n        <th>Preference</th>\r\n        <th>From</th>\r\n        <th>To</th>\r\n        ';
 } 
__p+='\r\n        ';
 if (simpleView) { 
__p+='\r\n        <th>Comment</th>\r\n        ';
 } 
__p+='\r\n        <th>History</th>\r\n        ';
 if (canEdit) { 
__p+='\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n        ';
 } 
__p+='\r\n        <th>Creation Source</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n';
 if (canEdit) { 
__p+='\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-contact">Add New Contact</button>\r\n</div>\r\n';
 } 
__p+='\r\n<div id="yes-no-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/contacts/contacts-table.html
// module id = 252
// module chunks = 0